import { createApi } from "@reduxjs/toolkit/query/react";
import {
  baseQueryWithArgs,
  getQueryStringWithCreator,
  postQueryBodyWithCreator,
} from "../../../utils/reduxHelper";

export const productReviewReduxAPI = createApi({
  reducerPath: "productReviewReduxAPI",
  baseQuery: baseQueryWithArgs,
  tagTypes: ["ProductReview", "WishlinkOrders"],

  endpoints: (builder) => ({
    getWishlinkOrders: builder.query({
      query: (page = 1) =>
        getQueryStringWithCreator(
          `s/product-review/wishlink-orders/?page=${page}`
        ),
      providesTags: ["WishlinkOrders"],
    }),
    getProductReview: builder.query({
      query: (productId) => ({
        url: `s/product-review/${productId}/`,
        method: "GET",
      }),
      providesTags: (result, error, productId) => [
        { type: "ProductReview", id: productId },
      ],
    }),
    getProductReviewUploadUrls: builder.mutation({
      query: (body) => ({
        url: "s/product-review/upload-urls/",
        method: "POST",
        body: postQueryBodyWithCreator(body),
      }),
    }),
    submitProductReview: builder.mutation({
      query: (body) => ({
        url: "s/product-review/submit/",
        method: "POST",
        body: postQueryBodyWithCreator(body),
      }),
      invalidatesTags: (result, error, body) => [
        { type: "ProductReview", id: body.product_id },
        "WishlinkOrders",
      ],
    }),
  }),
});

export const {
  useLazyGetWishlinkOrdersQuery,
  useGetProductReviewQuery,
  useGetProductReviewUploadUrlsMutation,
  useSubmitProductReviewMutation,
} = productReviewReduxAPI;
